const AUTH_API_URL = '/api/auth';

class AuthService {
  constructor() {
    this.baseURL = AUTH_API_URL;
  }

  getToken() {
    return localStorage.getItem('auth_token');
  }

  setToken(token) {
    localStorage.setItem('auth_token', token);
  }

  removeToken() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
  }

  getUser() {
    const user = localStorage.getItem('auth_user');
    return user ? JSON.parse(user) : null;
  }

  setUser(user) {
    localStorage.setItem('auth_user', JSON.stringify(user));
  }

  isAuthenticated() {
    return !!this.getToken();
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const token = this.getToken();
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('Auth API request failed:', error);
      throw error;
    }
  }

  async login(username, password) {
    const data = await this.request('/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });

    this.setToken(data.token);
    this.setUser(data.user);
    return data;
  }

  async register(username, password, role = 'user', name = '', bagian = 'Umum', cabangId = null) {
    return this.request('/register', {
      method: 'POST',
      body: JSON.stringify({ username, password, role, name, bagian, cabangId }),
    });
  }

  async registerPublic(username, password, name = '', bagian = 'Umum') {
    const url = `${this.baseURL}/register/public`;
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password, name, bagian }),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }
    return data;
  }

  async getMe() {
    return this.request('/me');
  }

  async getUsers() {
    return this.request('/users');
  }

  async updateUser(id, data) {
    return this.request(`/users/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async deleteUser(id) {
    return this.request(`/users/${id}`, {
      method: 'DELETE',
    });
  }

  async logout() {
    try {
      // Notify server to log the logout event (fire-and-forget)
      await this.request('/logout', { method: 'POST' });
    } catch (e) {
      // Ignore errors — token will be removed anyway
    }
    this.removeToken();
  }
}

export const authService = new AuthService();
export default authService;
